import { createSlice } from '@reduxjs/toolkit';

interface IState {
    dropdownValue: {
        title: string;
        group: string;
        tab: number;
    };
}

const initialState: IState = {
    dropdownValue: {
        title: '',
        group: '',
        tab: 0
    }
};

export const eAdvisorSlice = createSlice({
    name: 'eAdvisor',
    initialState,
    reducers: {
        setDropdownValue(state, action) {
            state.dropdownValue = action.payload;
        },
        clearDropdownValue(state) {
            state.dropdownValue = initialState.dropdownValue;
        }
    }
});

export const { setDropdownValue, clearDropdownValue } = eAdvisorSlice.actions;

export default eAdvisorSlice.reducer;
